export const locale = {
  lang: 'en',
  data: {
    'PORTAL': {
      'BTN_SCREE_SHO':'Take screenshot',
      'TOTALCOLA':'Total employees',
      'TOTALFAL': 'Employees who have not yet responded',
      'TOTALCONT':'Employees who have already responded',
      'TOTALPRO': 'Total progress',
      'TOTALLOG':'Employees who has not finish their survey',
      'REPORTE':'Recommended number of responses for...',
      'RANKING':'Minimum number of responses for...',
      'TOOLT_REPORTE':'Recommended number of responses for delivery of statistically significant results by demographic cut-off',
      'TOOLT_RANKING':'Minimum number of responses for Certification/Ranking of the company',

      'REPORTE_CER_CARCA':'Recommended number of responses to...',
      'TOOLT_REPORTE_CER_CARCA':'Recommended number of responses to deliver results statistically by demographic cut-off, taking into account that each option will get 5 responses',
      'RANKING_CER_CARCA':'Minimum number of responses to...',
      'TOOLT_RANKING_CER_CARCA':'Minimum number of responses for Certification / Ranking of the organization ',

      'REPORTE_MED_CARCA':'Recommended number of responses to...',
      'TOOLT_REPORTE_MED_CARCA':'Recommended number of responses to deliver results statistically by demographic cut-off, taking into account that each option will get 5 responses',
      'RANKING_MED_CARCA':'Minimum number of responses to...',
      'TOOLT_RANKING_MED_CARCA':'Minimum number of responses for Certification / Ranking of the organization',

      'TOTALMIN':'Employees minimum required',
      'TOTALGONE':'People whpo decided not answered',
      'SELECTFPLA': 'Filters',
      'TBARRAPROGRESO':'Current progress',
      'ACCESODENEGADO': 'Expired access link',
      'ACCESOMSJPRE_1': 'The closing date of the survey has been reached, this portal will still be active for ',
      'ACCESOMSJPRE_2': ' days',
      'BTNOK': 'OK',
      'DIARESTA':'Remaining day',
      'NO-INFO':'Absent information in the collaborators database',
      'COLAB':'Employees',
      'PORTAL_V1':'Counting portal V1',
      'PORTAL_V2':'Counting portal V2',
      'DI-TRANSCU':'Elapsed days',
      'ETI_GRAFI_ZONA_HO': 'The date shown in the graph is set to local time in: ',
      'ETI_FILT_V1&V2': 'The groups marked with ( * ) do not show information because they do not have the minimum number of users required to display the progress ',
      'WAR_RESU_ARE_MIN5': 'The minimum number of responses to display results per area is 5',
      'FILTROS':{
        '1': 'Country',
        '2': 'Location',
        '3': 'Area- Department',
        '4': 'Academic Degree',
        '5': 'Department',
        '6': 'Geographic Level 1',
        '7': 'Geographic Level 2',
        '8': 'Geographic Level 3',
        '9': 'Geographic Level 4',
        '10': 'Geographic Level 5',
        '11': 'Geographic Level 6',
        '12': 'Geographic Level 7',
        '13': 'Geographic Level 8',
        '14': 'Geographic Level 9',
        '15': 'Geographic Level 10',
        '16': 'Structural Level 1',
        '17': 'Structural Level 2',
        '18': 'Structural Level 3',
        '19': 'Structural Level 4',
        '20': 'Structural Level 5',
        '21': 'Structural Level 6',
        '22': 'Structural Level 7',
        '23': 'Structural Level 8',
        '24': 'Structural Level 9',
        '25': 'Structural Level 10',
        '26': 'Business Area',
        '27': 'Structural Level 2',
      },
      'COLUMNAS_TABLA':{
        'NIVEL1': 'Level 1',
        'NIVEL2': 'Level 2',
        'DEMOGRAFICO': 'Demographic',
        'SEGMENTO': 'Segment',
        'COLABORADORES_T': 'Total number of collaborators',
        'PENDIENTES_RESPONDER': 'Collaborators who have not yet responded',
        'YA_RESPONDIERON': 'Collaborators who have already responded',
        'AVANCE': 'Preview',
        'FILTERS': 'Filters'
      },
      'EXCEL_V2':{
        'TITULO_AVANCE': 'Progress on the implementation of the survey by: ',
        'SHEET': 'Report',
        'DESCARGA': 'Counting portal of ',
        'MODAL_DESCARGA': 'Correct unloading'
      },
      'ETIQUETAS':{
        'ETIQUETAS': 'Items per page',
        'OF': 'of',
        'BOTON':'Reset filters'
      },
      'FILTROS_V2':{
        'ninguno': 'None',
        'Company': 'Company',
        'country': 'Country',
        'location': 'Location',
        'area': 'Area',
        'antiquity': 'Antiquity',
        'generation': 'Generation',
        'charge': 'Charge',
        'homologado': 'Homologado',
        'gender': 'Gender',
        'typeofwork': 'Type of work',
        'workCondition': 'Work conditions',
        'academico': 'Academic Degree',
        'contratacion': 'Type of contract',
        'personal': 'Type of personnel',
        'geo_1': 'Geographic level 1',
        'geo_uno': 'Geographic level 1',
        'geo_2': 'Geographic level 2',
        'geo_3': 'Geographic level 3',
        'geo_4': 'Geographic level 4',
        'geo_5': 'Geographic level 5',
        'geo_6': 'Geographic Level 6',
        'geo_7': 'Geographic Level 7',
        'geo_8': 'Geographic Level 8',
        'geo_9': 'Geographic Level 9',
        'geo_10': 'Geographic Level 10',
        'structure_1': 'Structural level 1',
        'structure_2': 'Structural level 2',
        'structure_3': 'Structural level 3',
        'structure_4': 'Structural level 4',
        'structure_5': 'Structural level 5',
        'structure_6': 'Structural level 6',
        'structure_7': 'Structural level 7',
        'structure_8': 'Structural level 8',
        'structure_9': 'Structural level 9',
        'structure_10': 'Structural level 10',
        //////CLAVES PARA PORTAL DE CONTEOS///
        'structure_uno': 'Structural level 1',
        'structure_DOS': 'Structural level 2',
        'structure_TRES': 'Structural level 3',
        'structure_CUATRO': 'Structural level 4',
        'structure_CINCO': 'Structural level 5',
        'structure_SEIS': 'Structural level 6',
        'structure_SIETE': 'Structural level 7',
        'structure_OCHO': 'Structural level 8',
        'structure_NUEVE': 'Structural level 9',
        'structure_DIEZ': 'Structural level 10',
        'bUnit': 'Business Unit',
      },
      'FILTROS_V2_HK':{
        'ninguno': 'None',
        'Company': 'Company',
        'country': 'Country',
        'location': 'Location',
        'area': 'Department',
        'antiquity': 'Antiquity',
        'generation': 'Generation',
        'charge': 'Position or function in the company',
        'homologado': 'Approved',
        'gender': 'Gender',
        'typeofwork': 'Type of work',
        'workCondition': 'Work conditions',
        'academico': 'Academic Degree',
        'contratacion': 'Type of contract',
        'personal': 'Type of personnel',
        'geo_1': 'Geographic level 1',
        'geo_uno': 'Geographic level 1',
        'geo_2': 'Geographic level 2',
        'geo_3': 'Geographic level 3',
        'geo_4': 'Geographic level 4',
        'geo_5': 'Geographic level 5',
        'geo_6': 'Geographic Level 6',
        'geo_7': 'Geographic Level 7',
        'geo_8': 'Geographic Level 8',
        'geo_9': 'Geographic Level 9',
        'geo_10': 'Geographic Level 10',
        'structure_1': 'Structural level 1',
        'structure_2': 'Structural level 2',
        'structure_3': 'Structural level 3',
        'structure_4': 'Structural level 4',
        'structure_5': 'Structural level 5',
        'structure_6': 'Structural level 6',
        'structure_7': 'Structural level 7',
        'structure_8': 'Structural level 8',
        'structure_9': 'Structural level 9',
        'structure_10': 'Structural level 10',
        //////CLAVES PARA PORTAL DE CONTEOS///
        'structure_uno': 'Structural level 1',
        'structure_DOS': 'Structural level 2',
        'structure_TRES': 'Structural level 3',
        'structure_CUATRO': 'Structural level 4',
        'structure_CINCO': 'Structural level 5',
        'structure_SEIS': 'Structural level 6',
        'structure_SIETE': 'Structural level 7',
        'structure_OCHO': 'Structural level 8',
        'structure_NUEVE': 'Structural level 9',
        'structure_DIEZ': 'Structural level 10',
        'bUnit': 'Business Unit',
      },
      'PRODUCTO':{
        'CERT': 'Certify',
        'MED': 'Measure',
        'NOM35': 'Standard 035',
        'PULSE': 'Pulsecheck',
        'FOCUS': 'Focus Area',
        'MEDIR_1': 'Measurement enhanced',
        'MEDIR_2': 'Measurement + MST',
        'MEDIR_3': 'Measurement by areas',
        'MEDIR_4': 'Measurement by leaders',
        'MEDIR_5': 'Measurement by dimensions',
        'MEDIR_6': 'Measurement to certify',
        'NAME':'Company: ',
        'PRODUCTO':'Product: ',
        'PORTAL':'Counting portal ',
        'CGOX': 'CGO Express',
        'LEADER_GO':'Leader Go',
        'AMCO':'AMCO',
        'TRAB_DIGN':'Decent work',
        'PRI_EMPLE':'First job',
        'GPTW_GCTI': 'GPTW + GCTI'

      },
      'EXCEL':{
        'NOMBOTON': 'Export excel',
        'NOMBOTONREDUCIDO': 'Export to excel reduced',
        'NOMEMPRE': 'COMPANY NAME:',
        'NOMUSUARIO': 'USER NAME:',
        'NOMPROD': 'PRODUCT NAME:',
        'FERTILITY': 'LAUNCH DATE:',
        'FECHDESCA': 'DATE OF DOWNLOAD:',
        'DRESTAN':'REMAINING DAY:',
        'TOTALCOLA': 'TOTAL EMPLOYEES:',
        'TOTALCONT': 'EMPLOYEES WHO HAVE ALREADY RESPONDED:',
        'TOTALFAL': 'EMPLOYEES WHO HAVE NOT YET RESPONDING:',
        'TOTALPRO': 'TOTAL PROGRESS:',
        'REPORT': 'RESPONSE RATE FOR DELIVERABLES (minimum 85%):',
        'RANKING': 'SAMPLE FOR CERTIFICATION AND RANKING:',
        'FILT': 'FILTER:',
        'NOMFILT':' FILTER NAME:',
        //pestaña principal
        'INFOGENE': 'General Report',
        'FILTROSNAME':{
          'country':'country',
          'location':'location',
          'area':'area',
          'antiquity':'antiquity',
          'generation':'generation',
          'charge':'charge',
          'homologado':'homologado',
          'gender':'gender',
          'typeofwork':'typeofwork',
          'workCondition':'workCondition',
          'academico': 'academico',
          'contratacion': 'contratacion',
          'personal': 'personal',
          'geo_1':'geo_1',
          'geo_2':'geo_2',
          'geo_3':'geo_3',
          'geo_4':'geo_4',
          'geo_5':'geo_5',
          'structure_1':'structure_1',
          'structure_2':'structure_2',
          'structure_3':'structure_3',
          'structure_4':'structure_4',
          'structure_5':'structure_5',
          'structure_6':'structure_6',
          'structure_7':'structure_7',
          'structure_8':'structure_8',
          'structure_9':'structure_9',
          'structure_10':'structure_10',
        }
      },
      'TIPO-PERSONAL':{
        'TIPO':'Personal Type',
        '1':'Syndicated',
        '2':'Trust',
        '3':'Both',
      }

    },
    'PORTAL35': {
      'TOTALCOLA':'Total employees',
      'TOTALFAL': 'Employees who have not yet responded',
      'TOTALCONT':'Employees who have already responded',
      'TOTALPRO': 'Sample',
      'SELECTFPLA': 'Works center',
      'TBARRAPROGRESO':'Total progress',
      'TOTALLOG':'Employees who has not finish their survey',
      'TOTALGONE':'People whpo decided not answered',
      'FILTROS':{
        '1': "Work center",
        '2': 'Country',
        '3': 'Location',
        '4': 'Area',
        '5': 'Academic Degree',
        '6': 'Department',
        '7': 'Geographical Level 1',
        '8': 'Geographic Level 2',
        '9': 'Geographic Level 3',
        '10': 'Geographic Level 4',
        '11': 'Structural Level 1',
        '12': 'Structural Level 2',
        '13': 'Structural Level 3',
        '14': 'Geographic Level 8',
        '15': 'Geographical Level 9',
        '16': 'Geographic Level 10',
        '17': 'Hierarchical Level 1',
        '18': 'Hierarchical Level 2',
        '19': 'Hierarchical Level 3',
        '20': 'Hierarchical Level 4',
        '21': 'Hierarchical Level 5',
        '22': 'Hierarchical Level 6',
        '23': 'Hierarchical Level 7',
        '24': 'Hierarchical Level 8',
        '25': 'Hierarchical Level 9',
        '26': 'Hierarchical Level 10',
      }

    },
    'BTN':{
      'USERS':'Collaborators'
    }
  }

};
